import { getContestTemplateById } from '~/services/contests/contests.service.api';

import { memoize } from './memoize';

const getContestTemplateFromApi = async (contestTemplateId: string, authToken?: string) => {
  const data = await getContestTemplateById(contestTemplateId, authToken);
  return data;
};

export const getContestTemplate = async (contestTemplateId: string, authToken?: string) =>
  memoize(
    `${contestTemplateId}:${authToken ? 'auth' : 'unauth'}`,
    () => getContestTemplateFromApi(contestTemplateId, authToken),
    1000
  );
